import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
  TemplateRef,
  ViewChild,
  HostListener,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SocketioService } from '../services/socketio.service';
import { ApiService } from '../services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidateRoomData } from './validateroom.model';
import { AlertMessageService } from '../alerts/alertmsg.service';
import { HttpErrorResponse } from '@angular/common/http';
import { RecordingService } from '../services/recording.service';
import { RemoteUserSessionData } from './sessiondata.model';
import { io, Socket } from 'socket.io-client';
import { ChartConfiguration } from 'chart.js';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
declare const faceapi: any;

@Component({
  selector: 'app-meeting',
  templateUrl: './meeting.component.html',
  styleUrl: './meeting.component.scss',
})
export class MeetingComponent implements OnInit, AfterViewInit {
  muteAudio: boolean = false;
  showEmotions: boolean = false;
  socket: Socket;
  invitationForm: FormGroup;
  displayLocalTemplate: TemplateRef<any>;
  displayVideoTemplate: TemplateRef<any>;
  remoteActions: string;
  call_type: string;
  detection_paylod: any;
  local_user_details: RemoteUserSessionData;
  remote_user_details: RemoteUserSessionData;
  recorder: RecordingService;
  local_video: MediaStream;
  localVideoRecording: boolean = false;
  emotions: Array<any> = [];
  isMobile: boolean;
  isUserInfoSent: boolean = false;
  isExternal = false;
  @ViewChild('showLocalVideo') private showLocalVideo: TemplateRef<any>;
  @ViewChild('showLocalAudio') private showLocalAudio: TemplateRef<any>;
  @ViewChild('localvideo') private localvideo: TemplateRef<any>;
  @ViewChild('remotevideo') private remotevideo: TemplateRef<any>;

  @HostListener('window:beforeunload', ['$event'])
  async unloadHandler(event: Event) {
    const status = await this.updateBrowserSessionOnDisconnect();

    if (status === 'Completed') {
      this.ss.socket.emit('hangup-remote-call', true);
      if (this.apiservice.session_details.ishost) {
        this.destroyRoomSession(
          this.apiservice.session_details.session_id,
          this.apiservice.session_details.roomid
        );
      } else {
        this.apiservice.localVideoStream.next(null);
        this.apiservice.remoteVideoStream.next(null);
        this.ss.socket.close();
        localStorage.clear();
      }
    } else {
      console.log(status);
    }
  }

  // Emotional Analysis Chart
  public emotionAnalysislables: string[] = [
    '00:00:02',
    '00:00:04',
    '00:00:06',
    '00:00:08',
    '00:00:10',
    '00:00:12',
    '00:00:14',
    '00:00:16',
    '00:00:18',
    '00:00:20',
    '00:00:22',
    '00:00:24',
    '00:00:26',
    '00:00:28',
    '00:00:30',
    '00:00:32',
    '00:00:34',
    '00:00:36',
    '00:00:38',
    '00:00:40',
    '00:00:42',
    '00:00:44',
    '00:00:46',
    '00:00:48',
    '00:00:50',
  ];

  public emotionAnalysislegend = true;

  public emotionAnalysisoptions: ChartConfiguration<'line'>['options'] = {
    responsive: true,
    scales: {
      x: { title: { display: true, text: 'Video Timeline' } },
      y: { title: { display: true, text: 'Emotions' } },
    },
  };

  public emotionAnalysisdataSets: ChartConfiguration<'line'>['data']['datasets'] =
    [
      {
        label: 'Ambiguity',
        data: [
          0, 0, 0, 0.1, 0.15, 0.2, 0.25, 0.1, 0.1, 0.15, 0.15, 0.15, 0.7, 0.7,
          0.7, 0.3, 0.2, 0.1, 0, 0.1, 0.15, 0.2, 0.25, 0.2, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(255, 127, 0, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Angry',
        data: [
          0, 0.5, 0.7, 0.8, 0.7, 0.9, 1, 1.3, 1.2, 1.1, 0.7, 0.9, 1, 1.3, 1.5,
          0.7, 1, 0.8, 0.7, 0.5, 1, 0.2, 0.3, 0.2, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(227, 26, 28, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Fearful',
        data: [
          0, 0.1, 0.15, 0.2, 0, 0.05, 0.1, 0.15, 0.6, 0.8, 1, 0.9, 0.8, 0.6, 0,
          0.1, 0.35, 0.1, 0.15, 0.2, 0.7, 1, 0.5, 0.3, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(251, 154, 153, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Disgusted',
        data: [
          0, 0.15, 0.2, 0.9, 1, 0.6, 0.8, 1, 1.2, 1.4, 2, 1.3, 1.2, 1, 0.9, 0.1,
          0, 1.2, 1, 0.9, 0.6, 1.2, 0.9, 0.4, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(253, 191, 111, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Happy',
        data: [
          0, 0.2, 0.25, 0.7, 0.3, 1.8, 0.7, 1.9, 1.2, 2.1, 2.2, 3.1, 1.1, 1,
          0.7, 0.7, 1.9, 1.7, 2.1, 1.8, 1.7, 1.2, 0, 0.4, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(0, 209, 189, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Neutral',
        data: [
          0, 0, 0, 1, 1.1, 2.2, 2.2, 1.9, 3.6, 1.9, 2.1, 2.2, 3.7, 2.5, 2.4,
          1.7, 1.7, 3.5, 2.3, 2.2, 0, 1, 1.1, 1.8, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(0, 168, 186, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Sad',
        data: [
          0, 0.8, 0.9, 1.4, 1.6, 2.2, 0.1, 0, 3.1, 0.9, 0.8, 3.9, 2, 2, 4.6, 0,
          3.9, 3.1, 3, 2.2, 1.8, 1.7, 0, 1, 0.7, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(31, 120, 180, 0.8)',
        pointRadius: 0,
      },
      {
        label: 'Surprised',
        data: [
          0, 0, 0, 1.7, 1.9, 3.6, 1.8, 3.6, 0.9, 2.6, 2.6, 4.5, 4.6, 5.4, 1.8,
          2.4, 2.5, 3.6, 1.8, 1.8, 1.8, 0.9, 0.9, 0.5, 0,
        ],
        fill: true,
        tension: 0.5,
        borderColor: 'transparent',
        backgroundColor: 'rgba(166, 206, 227, 0.8)',
        pointRadius: 0,
      },
      // END Emotional Analysis Chart
    ];

  constructor(
    protected ss: SocketioService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public apiservice: ApiService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private recordingService: RecordingService,
    private alertMsg: AlertMessageService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.recorder = this.recordingService;
    this.socket = this.ss.socket;
    console.log('this.socket >>> ', this.socket);
  }

  ngOnInit(): void {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isMobile = result.matches;
        if (this.isMobile) {
          this.apiservice.showScreenShare.next(false);
        }
      });
    this.isExternal =
      this.activatedRoute.snapshot.queryParamMap.get('mode') === 'external'
        ? true
        : false;
    const sessionId =
      this.activatedRoute.snapshot.queryParamMap.get('session_id');
    const appData = {
      isExternal: this.isExternal,
      sessionId: sessionId,
    };
    if (appData && this.isExternal) {
      sessionStorage.setItem('appData', JSON.stringify(appData));
    }

    this.activatedRoute.params.subscribe((params: Params) => {
      this.apiservice.session_details.roomid = params['id'];
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.apiservice.session_details.session_id = params['session_id'];
      this.apiservice.session_details.calltype = params['calltype'];
      if (params['audioStatus'] === 'true') {
        this.apiservice.session_details.audio_status = true;
      }
      if (params['audioStatus'] === 'false') {
        this.apiservice.session_details.audio_status = false;
      }
      if (params['videoStatus'] === 'true') {
        this.apiservice.session_details.video_status = true;
      }
      if (params['videoStatus'] === 'false') {
        this.apiservice.session_details.video_status = false;
      }
      this.apiservice.session_details.user_name = params['name'];
      this.apiservice.session_details.socket_id = this.socket.id;
      if (this.apiservice.session_details.session_id.length) {
        this.validateRoom();
      }
    });

    this.invitationForm = this.fb.group({
      name: [null, [Validators.required]],
    });

    this.ss.socket.on('connect', () => {
      this.apiservice.session_details.socket_id = this.socket.id;
      this.apiservice.local_view_data.room =
        this.apiservice.session_details.roomid;
      this.apiservice.local_view_data.audioStatus =
        this.apiservice.session_details.audio_status;
      this.apiservice.local_view_data.videoStatus =
        this.apiservice.session_details.video_status;
      this.apiservice.local_view_data.uname =
        this.apiservice.session_details.user_name;
      this.apiservice.local_view_data.id =
        this.apiservice.session_details.socket_id;
    });

    this.ss.socket.on('disconnect', () => {
      console.log('Disconnected >>>');
      if (!this.isUserInfoSent) {
        this.ss.socket.emit('join', {
          uname: this.apiservice.session_details.user_name,
          room: this.apiservice.session_details.roomid,
          host: this.apiservice.session_details.ishost,
          session_id: this.apiservice.session_details.session_id,
        });
      }
    });

    this.ss.socket.on('bye', (id) => {
      this.apiservice.handleRemoteHangup(id);
      // this.destroyRoomSession(
      //   this.apiservice.session_details.session_id,
      //   this.apiservice.session_details.roomid
      // );
    });

    this.ss.socket.on('host', (isHost: boolean) => {
      this.apiservice.session_details.ishost = isHost;
      this.apiservice.local_view_data.host = isHost;
      this.isUserInfoSent = true;
    });

    this.ss.socket.on('full', () => {
      this.alertMsg.alertWarning(
        'You are not allowed here! To make a call just click on exit'
      );
      // this.destroyRoomSession(
      //   this.apiservice.session_details.session_id,
      //   this.apiservice.session_details.roomid
      // );
    });

    this.ss.socket.on('alert', async () => {
      console.log('Socket Msg >> ', 'alert');
    });

    this.ss.socket.on('candidate', async (id, candidate) => {
      try {
        if (candidate) {
          await this.apiservice.peerConnections[id].addIceCandidate(candidate);
        }
      } catch (error) {
        console.log(error);
      }
    });

    this.ss.socket.on('answer', async (id, description) => {
      if (description.type === 'answer') {
        try {
          if (
            this.apiservice.peerConnections[id].signalingState ===
            'have-local-offer'
          ) {
            const remoteDesc = new RTCSessionDescription(description);
            await this.apiservice.peerConnections[id].setRemoteDescription(
              remoteDesc
            );
          }
        } catch (e) {
          console.error('Error setting remote description', e);
        }
      } else if (description.type === 'offer') {
        try {
          const remoteDesc = new RTCSessionDescription(description);
          await this.apiservice.peerConnections[id].setRemoteDescription(
            remoteDesc
          );
          const answer = await this.apiservice.peerConnections[
            id
          ].createAnswer();
          await this.apiservice.peerConnections[id].setLocalDescription(answer);
          this.ss.socket.emit('answer', id, answer);
        } catch (e) {
          console.error('Error in offer by host', e);
        }
      }
    });

    this.ss.socket.on('video-off-thumbnail', (user, status) => {
      console.log('Socket Msg  >>> ', 'video-off-thumbnail', user, status);
      console.log('Pause the Joinee video');
    });

    this.ss.socket.on('name-modification', (uName, user) => {
      console.log('Socket Msg  >>> ', 'name-modification', uName, user);
    });

    this.ss.socket.on('annotation-response-status', (data) => {
      console.log('Socket Msg  >>> ', 'annotation-response-status', data);
    });

    this.ss.socket.on('annotation-request-status', (status) => {
      console.log('Socket Msg  >>> ', 'annotation-request-status', status);
    });

    this.ss.socket.on('receive-emotional-ai-stats', (stats) => {
      // console.log('Socket Msg  >>> ', 'receive-emotional-ai-stats', stats);
      if (this.apiservice.session_details.ishost) {
        //client stats
        try {
          this.apiservice.client_datapoint.push(stats);
        } catch (error) {
          console.warn();
        }
      }
    });

    this.ss.socket.on('whiteboard-request-status', (url, user) => {
      console.log('Socket Msg  >>> ', 'whiteboard-request-status', url, user);
    });

    this.ss.socket.on('hangup-remote-call', async (data: any) => {
      console.log('Socket Msg  >>> ', 'hangup-remote-call', data);
      const status = typeof data === 'object' ? data.status : data;
      const message = data?.message || '';
      if (status) {
        const sessionstatus = await this.updateBrowserSessionOnDisconnect();
        if (sessionstatus === 'Completed') {
          if (message) {
            this.alertMsg.alertWarning(message);
          }

          if (this.apiservice.session_details.ishost) {
            this.destroyRoomSession(
              this.apiservice.session_details.session_id,
              this.apiservice.session_details.roomid
            );
            this.apiservice.stopTimer();
          } else {
            this.apiservice.localVideoStream.next(null);
            this.apiservice.remoteVideoStream.next(null);
            localStorage.clear();
            this.apiservice.stopTimer();
            this.ss.socket.close();
            if (this.isExternal) {
              this.sendToParent();

              this.apiservice.errorPage.next({
                heading: 'Thank You!',
                message: 'Your call is ended',
              });
              this.router.navigate([
                `/errorpage/${this.apiservice.session_details.session_id}`,
              ]);
            } else {
              this.router.navigate([
                `/feedback/${this.apiservice.session_details.roomid}`,
              ]);
            }
          }
        } else {
          console.log(status);
        }
      }
    });

    this.emotions = [
      { imgUrl: 'assets/images/thinking.svg', name: 'Ambiguity', per: 10 },
      { imgUrl: 'assets/images/angry.svg', name: 'Angry', per: 2 },
      { imgUrl: 'assets/images/crying.svg', name: 'Disgusted', per: 2 },
      { imgUrl: 'assets/images/scared.svg', name: 'Fearful', per: 0 },
      { imgUrl: 'assets/images/happy.svg', name: 'Happy', per: 4 },
      { imgUrl: 'assets/images/neutral.svg', name: 'Neutral', per: 0 },
      { imgUrl: 'assets/images/sad.svg', name: 'Sad', per: 0 },
      { imgUrl: 'assets/images/surprised.svg', name: 'Surprised', per: 0 },
    ];
  }

  ngAfterViewInit(): void {
    if (this.apiservice.validation?.call_type === 'video_call') {
      this.displayLocalTemplate = this.showLocalVideo;
    }
    if (this.apiservice.validation?.call_type === 'audio_call') {
      this.displayLocalTemplate = this.showLocalAudio;
    }

    this.apiservice.remoteVideoStream.subscribe((value: MediaStream) => {
      if (value) {
        setTimeout(() => {
          this.displayVideoTemplate = this.localvideo;
        }, 1000);
      }
    });

    this.apiservice.localVideoStream.subscribe((value: MediaStream) => {
      if (value) {
        this.local_video = value;
      }
    });

    this.apiservice.switchVideos.subscribe((value: boolean) => {
      if (value) {
        if (this.displayVideoTemplate === this.localvideo) {
          this.displayVideoTemplate = this.remotevideo;
        } else {
          this.displayVideoTemplate === this.localvideo;
        }
      }
    });

    this.cd.detectChanges();
  }

  gethost() {
    if (this.apiservice.remote_video) {
      return this.apiservice.remote_view_data.host ? 'Agent' : 'Customer';
    } else {
      return this.apiservice.session_details.ishost ? 'Agent' : 'Customer';
    }
  }

  validateRoom() {
    this.apiservice
      .validateRoomSession(
        this.apiservice.session_details.session_id,
        this.apiservice.session_details.roomid
      )
      .subscribe({
        next: (res: ValidateRoomData) => {
          this.apiservice.validation = res;
          const data = window.sessionStorage.getItem('appData');
          sessionStorage.clear();
          if (data) {
            sessionStorage.setItem('appData', data);
          }

          if (res.status === 200) {
            this.apiservice.session_details.calltype = res.call_type;
            if (res.call_type === 'audio_call') {
              this.apiservice.audio_call_configurations =
                res.audio_call_configurations;
              this.apiservice.config.iceServers.push(
                this.apiservice.audio_call_configurations.turn_server_credential
                  .turn
              );
            }
            if (res.call_type === 'video_call') {
              this.apiservice.video_call_configurations =
                res.video_call_configurations;
              this.apiservice.config.iceServers.push(
                this.apiservice.video_call_configurations.turn_server_credential
                  .turn
              );
            }

            if (res.call_type === 'video_call') {
              this.displayLocalTemplate = this.showLocalVideo;
            } else if (res.call_type === 'audio_call') {
              this.displayLocalTemplate = this.showLocalAudio;
            }
            this.startSession();
          } else {
            this.apiservice.errorPage.next({
              heading: 'Something Went Wrong!',
              message: 'The meeting link you requested is invalid or expired.',
            });
            this.router.navigate([
              `/errorpage/${this.apiservice.session_details.session_id}`,
            ]);
          }
        },
        error: (err: any) => {
          console.log(err);
          this.apiservice.errorPage.next({
            heading: 'Something Went Wrong!',
            message: 'The meeting link you requested is invalid or expired.',
          });
          this.router.navigate([
            `/errorpage/${this.apiservice.session_details.session_id}`,
          ]);
        },
      });
  }

  startSession() {
    this.ss.socket.connect();
    if (this.apiservice.session_details.roomid) {
      this.ss.socket.emit('join', {
        uname: this.apiservice.session_details.user_name,
        room: this.apiservice.session_details.roomid,
        host: this.apiservice.session_details.ishost,
        session_id: this.apiservice.session_details.session_id,
      });
    }
  }

  getShortName(fullName) {
    return fullName
      .split(' ')
      .map((n) => n[0])
      .join('');
  }

  destroyRoomSession(session_id: string, room_id: string) {
    this.apiservice.destroyRoomSession(session_id, room_id).subscribe({
      next: (res) => {
        if (res) {
          this.apiservice.localVideoStream.next(null);
          this.apiservice.remoteVideoStream.next(null);
          this.apiservice.stopTimer();
          this.ss.socket.disconnect();
          localStorage.clear();
          const profile_id = window.sessionStorage.getItem(
            'covniaIO.webrtc.profileId'
          );

          if (this.apiservice.remote_video) {
            if (this.isExternal) {
              this.sendToParent();

              this.apiservice.errorPage.next({
                heading: 'Thank You!',
                message: 'Your call is ended',
              });
              this.router.navigate([`/errorpage/${profile_id}`]);
            } else {
              this.router.navigate([`/feedback/${profile_id}`]);
            }
          } else {
            if (this.isExternal) {
              this.sendToParent();
            }
            this.apiservice.errorPage.next({
              heading: 'Thank You!',
              message: 'Your call is ended',
            });
            this.router.navigate([`/errorpage/${profile_id}`]);
          }
        }
      },
      error: (err: HttpErrorResponse) => {
        if (err.status === 400) {
          this.apiservice.localVideoStream.next(null);
          this.apiservice.remoteVideoStream.next(null);
          this.apiservice.stopTimer();
          this.ss.socket.disconnect();
          localStorage.clear();
          const profile_id = window.sessionStorage.getItem(
            'covniaIO.webrtc.profileId'
          );
          if (this.apiservice.remote_video) {
            if (this.isExternal) {
              this.sendToParent();

              this.apiservice.errorPage.next({
                heading: 'Thank You!',
                message: 'Your call is ended',
              });
            } else {
              this.router.navigate([`/feedback/${profile_id}`]);
            }
          } else {
            if (this.isExternal) {
              this.sendToParent();
            }

            this.apiservice.errorPage.next({
              heading: 'Thank You!',
              message: 'Your call is ended',
            });
            this.router.navigate([`/errorpage/${profile_id}`]);
          }
          this.alertMsg.alertDanger(err.error.error);
        }
      },
    });
  }
  sendToParent() {
    if (this.isExternal) {
      window.parent.postMessage(
        {
          type: 'CALL_ENDED',
          sessionId: JSON.parse(sessionStorage.getItem('appData'))?.sessionId,
        },
        '*'
      );
    }
  }
  async updateBrowserSessionOnDisconnect() {
    try {
      let date_end;
      let runningfalseStatus;
      let statsResponse: boolean;

      // stop recording by host
      if (this.apiservice.session_details.ishost) {
        this.recorder.stopRecording();
        if (
          this.apiservice.validation.call_type === 'video_call' &&
          this.apiservice.video_call_configurations.recording &&
          this.recorder.mediaRecorder
        ) {
          this.recorder.mediaRecorder.onstop = (event: any) => {};
        }

        if (
          this.apiservice.validation.call_type === 'audio_call' &&
          this.apiservice.audio_call_configurations.recording &&
          this.recorder.mediaRecorder
        ) {
          this.recorder.mediaRecorder.onstop = (event: any) => {};
        }
      }

      if (
        this.apiservice.validation.call_type === 'video_call' &&
        this.apiservice.video_call_configurations.emotional_ai &&
        this.apiservice.self_datapoint.length
      ) {
        const profile_id = sessionStorage.getItem('covniaIO.webrtc.profileId');
        const payload = { emotional_ai_stats: this.apiservice.self_datapoint };
        this.apiservice.postEmotionalAiStats(payload, profile_id).subscribe({
          next: (res) => {
            if (res) {
              statsResponse = true;
            }
          },
          error: (err) => {
            statsResponse = false;
          },
        });
      }

      if (statsResponse) {
        this.apiservice.self_datapoint = null;
        this.apiservice.client_datapoint = null;
      }
      runningfalseStatus = false;
      date_end = new Date(Date.now());
      window.sessionStorage.setItem(
        'covniaIO.webrtc.running',
        runningfalseStatus
      );
      window.sessionStorage.setItem('covniaIO.webrtc.ended_on', date_end);
      if (this.apiservice.timer$) {
        this.apiservice.timer$.subscribe((val) => {
          window.sessionStorage.setItem('covniaIO.webrtc.duration', val);
        });
        this.apiservice.stopTimer();
      }
      return 'Completed';
    } catch (error) {
      console.error('Error ', error);
      return error;
    }
  }

  EnableVideo() {
    console.log(this.local_video.getTracks());
    if (this.local_video.getVideoTracks()[0]) {
      this.local_video.removeTrack(this.local_video.getVideoTracks()[0]);
    }
    navigator.mediaDevices
      .getUserMedia(this.apiservice.video_call_constraints)
      .then(async (stream) => {
        let videotrack = stream.getVideoTracks()[0];
        this.local_video.addTrack(videotrack);
        this.apiservice.localVideoStream.next(this.local_video);
        if (videotrack.enabled) {
          for (let peers in this.apiservice.peerConnections) {
            let sender = this.apiservice.peerConnections[peers]
              .getSenders()
              .find((s) => {
                console.log('kind >>>> ', s, this.apiservice.pVt);
                if (s.track !== null) {
                  return s.track.kind === this.apiservice.pVt.kind;
                } else {
                  return null;
                }
              });

            if (sender) {
              console.log(sender);
              sender.replaceTrack(videotrack);
            } else {
              if (peers) this.apiservice.makeOffer = true;
              await this.apiservice.peerConnections[peers].addTrack(
                videotrack,
                this.local_video
              );
            }
            console.log(this.apiservice.peerConnections[peers]);
          }

          if (
            !this.apiservice.localVideoRecording &&
            Object.keys(this.apiservice.peerConnections).length
          ) {
            this.ss.socket.emit('stream-added-status', true);

            if (this.apiservice.session_details.ishost) {
              this.recorder.pauseAndResumeVideoStream([this.local_video]);
            }

            this.apiservice.localVideoRecording = true;
          }
        }
      });
    this.apiservice.localVideoStream.next(this.local_video);
    this.apiservice.session_details.video_status = true;
    this.ss.socket.emit('video-pause-status', false);
  }

  PauseVideo() {
    console.log('previous track >>> ', this.local_video.getTracks());
    let videoTrack = this.local_video.getVideoTracks()[0];
    videoTrack.enabled = false;
    this.apiservice.pVt = this.local_video.getVideoTracks()[0];
    videoTrack.stop();
    // Create a canvas element and set its dimensions
    const canvas = document.createElement('canvas');
    canvas.width = 640; // Set your desired width
    canvas.height = 480; // Set your desired height

    // Get a 2D rendering context
    const context = canvas.getContext('2d');

    // Draw a black rectangle on the canvas
    context.fillStyle = 'black';
    context.fillRect(0, 0, canvas.width, canvas.height);

    // Create a MediaStreamTrack from the canvas
    const blackVideoTrack = canvas.captureStream().getVideoTracks()[0];
    for (let peers in this.apiservice.peerConnections) {
      let sender = this.apiservice.peerConnections[peers]
        .getSenders()
        .find((s) => {
          if (s.track !== null) {
            return s.track.kind === this.apiservice.pVt.kind;
          } else {
            return null;
          }
        });

      if (sender) {
        sender.replaceTrack(blackVideoTrack);
      }
    }

    this.local_video.removeTrack(videoTrack);
    console.log(this.local_video.getTracks());
    this.apiservice.localVideoStream.next(this.local_video);
    this.apiservice.session_details.video_status = false;
    this.ss.socket.emit('video-pause-status', true);
  }

  format(num: number) {
    return (num + '').length === 1 ? '0' + num : num + '';
  }

  MuteAudio() {
    let audio = this.local_video;
    let stream = audio.getAudioTracks();
    stream[0].enabled = false;
    this.apiservice.localVideoStream.next(this.local_video);
    this.apiservice.session_details.audio_status = false;
    this.ss.socket.emit('audio-mute-status', true);
  }

  EnableAudio() {
    let audio = this.local_video;
    let stream = audio.getAudioTracks();
    stream[0].enabled = true;
    this.apiservice.localVideoStream.next(this.local_video);
    this.apiservice.session_details.audio_status = true;
    this.ss.socket.emit('audio-mute-status', false);
  }

  disconnectCall() {
    this.ss.socket.emit('hangup-remote-call', {
      room: this.apiservice.session_details.roomid,
      session_id: this.apiservice.session_details.session_id,
      status: true,
    });
  }

  toggleVideos() {
    this.apiservice.switchVideos.next(true);
  }

  //screen-sharing feature code
  // start screen share
  async startScreenShare() {
    let displayMediaOptions = {
      video: {
        cursor: 'always',
      },
    };
    try {
      //collecting screen
      const mediaDevices = navigator.mediaDevices as any;
      let shareScreen = await mediaDevices.getDisplayMedia(displayMediaOptions);
      let screen = shareScreen.getVideoTracks()[0];

      if (
        this.apiservice.session_details.video_status &&
        this.apiservice.remote_video
      ) {
        this.local_video.getVideoTracks()[0].stop();
        this.local_video.removeTrack(this.local_video.getVideoTracks()[0]);
        this.local_video.addTrack(screen);
        //changing the screen
        this.replaceTrack(screen);
      } else {
        let pVt = (<MediaStream>this.local_video).getVideoTracks()[0];
        for (let peers in this.apiservice.peerConnections) {
          let sender = this.apiservice.peerConnections[peers]
            .getSenders()
            .find((s: any) => {
              if (s.track !== null) {
                return s.track.kind === pVt.kind;
              } else {
                return null;
              }
            });

          if (sender) {
            sender.replaceTrack(screen);
          } else {
            if (peers) this.apiservice.makeOffer = true;
            await this.apiservice.peerConnections[peers].addTrack(
              screen,
              this.local_video
            );
          }
        }
        this.local_video.addTrack(screen);
      }
      this.apiservice.localVideoStream.next(this.local_video);
      this.apiservice.isScreenShare = true;
      //When the stop sharing button shown by the browser is clicked
      shareScreen.getVideoTracks()[0].addEventListener('ended', () => {
        this.stopCapture();
      });
    } catch (err) {
      console.error('Error: ' + err);
    }
  }

  replaceTrack(track) {
    for (let peer in this.apiservice.peerConnections) {
      let sender = this.apiservice.peerConnections[peer]
        .getSenders()
        .find((s) => {
          if (s.track !== null) {
            return s.track.kind == this.local_video.getVideoTracks()[0].kind;
          } else {
            return null;
          }
        });
      sender.replaceTrack(track);
    }
  }

  // stop screen share
  async stopCapture() {
    try {
      if (!this.apiservice.session_details.video_status) {
        let pVt = this.local_video.getVideoTracks()[0];
        this.local_video.removeTrack(pVt);

        for (let peers in this.apiservice.peerConnections) {
          let sender = this.apiservice.peerConnections[peers]
            .getSenders()
            .find((s) => {
              if (s.track !== null) {
                return s.track.kind === pVt.kind;
              } else {
                return null;
              }
            });
          sender.replaceTrack(pVt);
        }
      } else {
        let newVideo = await navigator.mediaDevices.getUserMedia(
          this.apiservice.validation.call_type === 'video_call'
            ? this.apiservice.video_call_constraints
            : this.apiservice.audio_call_constraints
        );
        let video = newVideo.getVideoTracks()[0];
        let pvt = this.local_video.getVideoTracks()[0];
        pvt.stop();
        this.local_video.removeTrack(pvt);
        this.local_video.addTrack(video);
        //changing the screen
        this.replaceTrack(video);
      }
      this.apiservice.localVideoStream.next(this.local_video);
      this.apiservice.isScreenShare = false;
    } catch (error) {
      console.error('Error: ' + error);
    }
  }
}
